const { render, useState } = wp.element;
import React, { Component } from "react";
import { withTranslation } from "react-i18next";

//Import Designs
import {
    Typography,
    Grid2,
    Button,
    TextField,
    Dialog,
    DialogContent,
} from "@mui/material";
import ReactHtmlParser from "react-html-parser";
import ReCAPTCHA from "react-google-recaptcha";

import VoterDetails from "./VoterDetails.jsx";
import Newsletter from "./Newsletter.jsx";
import CustomReactValidator from "../CustomReactValidator.jsx";

class EmailGrab extends Component {
    constructor(props) {
        super(props);
        const { t } = this.props;

        this.validator = new CustomReactValidator({
            validators: {
                consent: {
                    message: t("consent_validation_text"),
                    rule: (val, params, validator) => {
                        return val || false;
                    },
                    messageReplace: (message, params) => {
                        return message.replace(":values", params);
                    },
                    required: true,
                },
            },
            messages: {
                email: this.props.t("email_validation"),
            },
        });
        const { vote_enable_recaptcha_voting } = this.props.settings.common;
        this.state = {
            recaptcha: null,
            captcha_verfied:
                vote_enable_recaptcha_voting != "on" ? true : false,
        };
    }

    submitForm = () => {
        if (this.validator.allValid() && this.state.captcha_verfied) {
            let post_index = this.props.indexpost;
            let vote_settings = this.props.settings.contest;

            let contest_settings = {};

            //Add the User ID from JS
            contest_settings.user_logged = this.props.short.user_logged;
            contest_settings.user_id_profile = this.props.short.user_id_profile;
            contest_settings.captcha_verfied = this.state.captcha_verfied;
            contest_settings = Object.assign(contest_settings, vote_settings);
            this.props.handleSaveVotes(
                this.props.singlepost.id,
                this.props.singlepost.term_id,
                contest_settings,
                post_index,
                this.props.email_address
            );
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    onCaptchaClick = (value) => {
        this.props.handleCaptchaChange(value);
        if (value) {
            this.props.verifyCaptcha(this.props.SITE_URL, value).then((val) => {
                this.setState({ captcha_verfied: val.verified });
            });
        }
    };

    render() {
        const { t } = this.props;
        let error_login = null;
        const { vote_enable_recaptcha_voting, vote_recapatcha_key } =
            this.props.settings.common;
        return (
            <Dialog
                open={this.props.showlog}
                maxWidth="sm"
                fullWidth={true}
                onClose={() => this.props.handclose()}
            >
                <DialogContent>
                    <TextField
                        className="wpvc_text_field"
                        type="text"
                        name="email_address"
                        label={t("enter_email_address")}
                        onChange={() => this.props.handleValueChange(event)}
                        fullWidth
                    />

                    {this.validator.message(
                        t("voter_email_required"),
                        this.props.email_address,
                        "required|email"
                    )}

                    <Newsletter {...this.props} email_field={true} />
                    <VoterDetails {...this.props} validator={this.validator} />

                    {vote_enable_recaptcha_voting == "on" &&
                        vote_recapatcha_key != "" && (
                            <Grid2
                                container
                                justifyContent="center"
                                style={{ marginTop: 20 }}
                            >
                                <Grid2 size={12}>
                                    <ReCAPTCHA
                                        sitekey={vote_recapatcha_key}
                                        onChange={this.onCaptchaClick}
                                    />
                                </Grid2>
                                <Grid2 size={12}>
                                    {this.validator.message(
                                        t("verify_captcha"),
                                        this.props.recaptcha,
                                        "required"
                                    )}
                                </Grid2>
                            </Grid2>
                        )}

                    <Grid2 container justifyContent="flex-start">
                        <Typography className="wpvc_error_login">
                            {ReactHtmlParser(error_login)}
                        </Typography>
                        <Button
                            variant="contained"
                            className="wpvc_login_btns"
                            color="secondary"
                            onClick={this.submitForm}
                        >
                            {t("fr_vote_now")}
                        </Button>
                    </Grid2>
                </DialogContent>
            </Dialog>
        );
    }
}

export default withTranslation("translations")(EmailGrab);
